import * as Types from '../../declarations'
import {
	IconBackpack,
	IconBed,
	IconBuildingHospital,
	IconBuildingStore,
	IconCash,
	IconHelicopter,
	IconMountain,
	IconOld,
	IconShoe,
	IconToolsKitchen2,
	IconWifi,
} from '@tabler/icons-react'

import { HighLevelItem } from './HighLevelSummary'
import SectionHeader from './components/SectionHeader'
import HTMLContent from 'components/HTMLContent'

interface Props {
	trip: Types.DB.Models.TripAttributes
}

const IconForTitle = (type: string) => {
	switch (true) {
		case type === 'Accommodation':
			return IconBed

		case type === 'Food':
			return IconToolsKitchen2

		case type === 'Guides':
			return IconOld

		case type === 'Porters':
			return IconBackpack

		case type === 'Medical facilities':
			return IconBuildingHospital

		case type === 'Gear rental':
			return IconShoe

		case type === 'Transport':
			return IconHelicopter

		case type === 'Internet / Phone':
			return IconWifi

		case type === 'ATMs':
			return IconCash

		case type === 'Shops':
			return IconBuildingStore

		default:
			return IconMountain
	}
}

const Services = ({
	trip: {
		name,
		jsonData: { services },
	},
}: Props) => {
	if (!services) return <></>

	return (
		<div id="services-wrapper" className="spacing-between-sections-above">
			<SectionHeader
				title={`${name} Services`}
				subtitle="Gear rental, porters, guides, transport, internet,
				accommodation"
				section={Types.App.DataTypes.FeedbackSection.SERVICES}
			/>
			{services.description && (
				<HTMLContent
					id="services-description"
					html={services.description}
				></HTMLContent>
			)}

			{services && (
				<div id="service-items">
					{services?.accommodation && (
						<HighLevelItem
							icon={IconForTitle('Accommodation')}
							title={'Accommodation'}
							content={<>{services?.accommodation}</>}
						/>
					)}
					{services?.food && (
						<HighLevelItem
							icon={IconForTitle('Food')}
							title={'Food'}
							content={<>{services?.food}</>}
						/>
					)}
					{services?.guides && (
						<HighLevelItem
							icon={IconForTitle('Guides')}
							title={'Guides'}
							content={<>{services?.guides}</>}
						/>
					)}

					{services?.porters && (
						<HighLevelItem
							icon={IconForTitle('Porters')}
							title={'Porters'}
							content={<>{services?.porters}</>}
						/>
					)}
					{services?.medical && (
						<HighLevelItem
							icon={IconForTitle('Medical facilities')}
							title={'Medical facilities'}
							content={<>{services?.medical}</>}
						/>
					)}
					{services?.gear && (
						<HighLevelItem
							icon={IconForTitle('Gear rental')}
							title={'Gear rental'}
							content={<>{services?.gear}</>}
						/>
					)}

					{services?.transport && (
						<HighLevelItem
							icon={IconForTitle('Transport')}
							title={'Transport'}
							content={<>{services?.transport}</>}
						/>
					)}
					{services?.communications && (
						<HighLevelItem
							icon={IconForTitle('Internet / Phone')}
							title={'Internet / Phone'}
							content={<>{services?.communications}</>}
						/>
					)}
					{services?.atms && (
						<HighLevelItem
							icon={IconForTitle('ATMs')}
							title={'ATMs'}
							content={<>{services?.atms}</>}
						/>
					)}

					{services?.shops && (
						<HighLevelItem
							icon={IconForTitle('Shops')}
							title={'Shops'}
							content={<>{services?.shops}</>}
						/>
					)}
				</div>
			)}
		</div>
	)
}

export default Services
